import { MoqPlayer } from '@optools/components/players/moq-player';
import { useState } from 'react';

import { MoqSourceForm, MoqSourceFormType } from './moq-source-form';

export function MoqCardContent() {
  const [playerSource, setPlayerSource] = useState<MoqSourceFormType>();

  return (
    <div className="flex flex-col gap-4 p-2">
      <MoqSourceForm onSubmit={setPlayerSource} />
      {playerSource ? (
        <MoqPlayer broadcastName={playerSource.broadcastName} relayUrl={playerSource.relayUrl} />
      ) : (
        <div className="flex aspect-video h-full w-full items-center justify-center rounded-lg bg-muted">
          <h3 className="text-sm font-medium text-muted-foreground">
            Enter Player Source to View Playback
          </h3>
        </div>
      )}
    </div>
  );
}
